export const environment = {
  production: false,
  apiUrl: 'https://sen-bac-staging-be.sigesr.sn/api/v1',
};
